import styled from 'styled-components';

export const ModalRoot = styled.div<{
  $mounted: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(76, 86, 103, 0.3);
  z-index: 10000;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  overflow: auto;
  backdrop-filter: blur(0.15rem);
  display: ${({ $mounted }) => ($mounted ? 'flex' : 'none')};
  overflow-x: hidden;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

export const ModalContainer = styled.div<{
  $backgroundColor: string;
  $width: string;
  $maxHeight?: string;
}>`
  padding: 1.5rem;
  display: grid;
  grid-template-rows: auto 1fr auto;
  border: 0.5rem solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  width: ${({ $width }) => $width};
  border-radius: ${({ theme }) => theme.borderRadius.radius20};
  margin: auto;
  margin-bottom: 1rem;
  position: relative;
  max-height: ${({ $maxHeight }) => $maxHeight};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    margin-bottom: 5.25rem;
    padding: 0.25rem;
  }
`;

export const ModalBody = styled.div<{ maxHeightModalBody?: string }>`
  overflow: hidden;
  overflow-y: auto;
  max-height: ${({ maxHeightModalBody }) => maxHeightModalBody ?? '75vh'};
  margin-right: 1.23rem;
`;

export const Footer = styled.div`
  border-top: 0.1rem solid ${({ theme }) => theme.color.lightGrey};
`;

export const Header = styled.div`
  min-height: 3.5rem;
`;
